import { ACCOUNT_TYPES } from './constants';

export const validateEmployeeNumber = (value) => {
  if (!value) {
    return '社員番号を入力してください。';
  }
  if (value.length !== 7) {
    return '7文字で入力してください。';
  }
  if (!/^[0-9]{7}$/.test(value)) {
    return '数字で入力してください。';
  }
  return '';
};

export const validateAccountType = (value) => {
  if (!value) return 'アカウント種類を入力してください。';
  const types = [];
  Object.values(ACCOUNT_TYPES).forEach((type) => {
    types.push(type.label, type.value.toString());
  });
  if (!types.includes(value)) return `アカウント種類は次の値で指定してください。${types}`;
};

export const validateName = (value) => {
  if (!value) return '氏名を入力してください。';
  // eslint-disable-next-line no-irregular-whitespace
  if (/　/.test(value)) return '氏名に全角スペースを含めないでください。';
  return '';
};

export const validateClassName = (value) => {
  let className = value;
  if (className.startsWith('新') || className.startsWith('旧')) {
    className = className.slice(1);
  }
  if (!/^[0-9]+$/.test(className) && className !== '') {
    return '半角数字を入力してください';
  }
  return '';
};

export const validatePassword = (value, isUpdate) => {
  if (!value && !isUpdate) return 'パスワードを入力してください。';
  return '';
};
